import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElAccordion = styled.section`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: var(--content-width);
  margin: 0 auto;
  padding-inline-start: 0;
  padding-inline-end: 0;
  gap: 15px;
`;
export const ElAccordionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  padding-inline-start: 0;
  padding-inline-end: 0;
  gap: 15px;
`;

export const ElAccordionAction = styled.button`
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  transition: 0.4s;
  background-color: var(--theme-main-color);
  /* background-image: linear-gradient(45deg, #10575c 0%, #297b10 100%); */
  color: #fff;
  padding: 2em;
  border-radius: 5px;
  font-size: 17px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  ${isMobile} {
    font-size: 14px;
  }
  svg {
    transition: all 0.5s;
  }
  &.active {
    /* height: 100% !important; */

    /* height: auto !important; */
    /* min-height: 1px; */
    svg {
      transform: rotate(90deg);
    }
  }
`;

export const ElAccordionPannelContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  overflow: hidden;
  background-color: #f5f5f5;
  padding: 1em;
  width: 100%;
  overflow: hidden;
  color: #000;
  font-style: normal;
  font-weight: 200;
  line-height: 150%; /* 48px */
  transition: all 0.3s;
  font-size: 17px;
  /* display: none; */
  position: relative;
  top: -100%;
  * {
    line-height: 1.5em;
  }
  ul {
    list-style: initial;
    padding-left: 21px;
  }
  ol {
    list-style: decimal;
    padding-left: 21px;
  }
  a {
    color: #000;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
`;

export const ElAccordionPannel = styled.div`
  display: flex;
  background-color: white;
  overflow: hidden;
  height: auto;
  background-color: #ffffff;
  width: 100%;
  height: 0;
  &.active {
    display: flex;
    height: auto;
    ${ElAccordionPannelContent} {
      top: 0;
    }
  }
`;
